import { queryOptions } from '@tanstack/react-query'

import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'
import type { ResCaseHistoryListQuery } from '@/lib/queries/business/v1/case/types'

export const getCaseHistoryListQuery = (caseNumber: string) =>
  queryOptions({
    queryKey: ['case', { caseNumber }],
    queryFn: (): Promise<ResCaseHistoryListQuery> =>
      w.url(`${API_ENDPOINTS.business.v1.case.index}/${caseNumber}`).query({ flag: 3 }).get().json(),
  })
